import { render, staticRenderFns } from "./LatestJobs.vue?vue&type=template&id=3da53145&"
import script from "./LatestJobs.vue?vue&type=script&lang=js&"
export * from "./LatestJobs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports